import React from "react";
import { ImageTooltip, ChantCheckbox } from "../../../../../CommonComponents";

import GeneralPaymentEmails from "../../../../../images/stripe/general-payments.png";
import CustomerPortalSettings from "../../../../../images/stripe/customer-portal-settings.png";
import BillingSettings from "../../../../../images/stripe/billing-settings.png";

import "./StripeSettings.css";

const StripeSettings = ({
  stripeSetupConfirmation,
  handleStripeSetupConfirmation,
}) => {
  const settings = [
    {
      label: "General Payment Emails",
      image: GeneralPaymentEmails,
      link: "https://dashboard.stripe.com/settings/emails",
      description: "Enable emails for 'Successful Payments' & 'Refunds'.",
    },
    {
      label: "Subscriptions",
      image: BillingSettings,
      link: "https://dashboard.stripe.com/settings/billing/automatic",
      description:
        "If offering subscriptions (auto-renewal) you must manage these settings for emails, payment updates and failed charge retries. See image.",
    },
    {
      label: "Customer Portal",
      image: CustomerPortalSettings,
      link: "https://dashboard.stripe.com/settings/billing/portal",
      description:
        "If offering subscriptions, enable the Stripe customer portal allowing members to manage payment details and cancel subscriptions. See image.",
    },
  ];

  return (
    <div className="stripe-settings-container">
      <h5>Stripe Settings</h5>
      <p>
        You must configure settings in Stripe for payments and subscriptions.
        Stripe does not provide Chant access to these settings. Engage{" "}
        <a href="mailto:support@chant.fan">support@chant.fan</a> to ensure
        settings are correct.
      </p>

      {settings.map((setting, index) => (
        <div
          key={index}
          className="stripe-setting-row"
          style={{
            borderBottom:
              index !== settings.length - 1 ? "1px solid #f0f0f0" : "none",
          }}
        >
          <div className="col-md-6 stripe-setting-left">
            <div className="stripe-setting-label">
              <span>{setting.label}</span>
            </div>
            <div className="stripe-setting-action">
              <ImageTooltip
                image={setting.image}
                title="Stripe Dashboard"
                link={setting.link}
              />
            </div>
          </div>
          <div className="col-md-6 hide-for-mobile stripe-setting-description">
            <span>{setting.description}</span>
          </div>
        </div>
      ))}

      <div className="stripe-confirmation-row">
        <div className="col-md-6 stripe-confirmation-left">
          <div className="stripe-confirmation-label">
            <span>Please confirm Stripe Settings have been updated</span>
          </div>
          <div className="stripe-confirmation-checkbox">
            <ChantCheckbox
              checked={stripeSetupConfirmation}
              onChange={(e) => {
                handleStripeSetupConfirmation(e.target.checked);
              }}
            />
          </div>
        </div>
        <div className="col-md-6 hide-for-mobile"></div>
      </div>
    </div>
  );
};

export default StripeSettings;
